import { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  MenuItem,
  Select,
  Button,
  CardMedia,
  IconButton,
  Input,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import EditText from "../../components/editText";

const AddBoostPlans = () => {
  const navigate = useNavigate();
  const [type, setType] = useState("default");
  const [category, setCategory] = useState("default");
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  const [legal1, setLegal1] = useState<string>("");
  const [legal2, setLegal2] = useState<string>("");

  return (
    <>
      <div className="main_title">
        <h1>Add Boost Plans</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-boost-plans")}>
            Manage Boost Plans
          </button>{" "}
          - Add Boost Plans
        </p>
      </div>

      <div className="cards">
        <form className="form" action="">
          <div className="gap_p">
            {/* Title */}
            <div className="control_group w_50">
              <label htmlFor="reward_title">Title</label>
              <TextField
                id="reward_title"
                placeholder="Enter Title"
                fullWidth
                hiddenLabel
              />
            </div>

            {/* Duration */}
            <div className="control_group w_33">
              <label htmlFor="duration">Duration</label>
              <TextField
                id="duration"
                type="number"
                placeholder="Enter Number of Days"
                fullWidth
                hiddenLabel
              />
            </div>
            {/* Duration */}
            <div className="control_group w_33">
              <label htmlFor="price">Price</label>
              <TextField
                id="price"
                type="number"
                placeholder="Enter Price"
                fullWidth
                hiddenLabel
              />
            </div>
            {/* Assign to Category */}
            <div className="control_group w_33">
              <label htmlFor="category">Assign to Category</label>
              <Select
                id="category"
                fullWidth
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              >
                <MenuItem disabled value="default">
                  Select Category
                </MenuItem>
                <MenuItem value="books">Books</MenuItem>
                <MenuItem value="uniforms">Uniforms</MenuItem>
                <MenuItem value="stationary">Stationary</MenuItem>
              </Select>
            </div>
          </div>

          <div className="form_btn">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-boost-plans")}
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddBoostPlans;
